

















































import { Component, Prop, Vue } from "@/common";

@Component({})
export default class SidebarItem extends Vue {
  @Prop() item: any;

  @Prop() isNest!: boolean;

  isSingle() {
    if (!this.item.children || this.item.children.length === 0) {
      return true;
    }
    return false;
  }
}
